import { render } from "./SiteFooter.vue?vue&type=template&id=86e137b6&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=86e137b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e137b6"]])

export default __exports__